/*
 * The two rules a Tailwind utility cannot carry: both fight a stylesheet injected outside any layer, and an
 * unlayered declaration beats `layer(utilities)` whatever its specificity.
 *
 * CodeMirror renders its own class tree and sets the editor bounds and the focus outline from its base theme.
 */
.editor :global(.cm-editor) {
  min-height: 30px;
  max-height: 400px;
}

.editor :global(.cm-focused) {
  outline: none;
}

/*
 * The classic form pins every field to 300px through `FormWrapper ${BaseInputElement}`, and an array param is the one
 * that wants the 600px its own wrapper gives it. `ChipListInput` takes a className for its outer div only, so the
 * element that rule targets — the input component's root, not the native `input` the chip list sizes to the text
 * being typed — is reached as its child, and the class is repeated to outweigh those two classes rather than leave
 * the tie to whichever stylesheet lands last. Both go away once `FormWrapper` states each field's width itself.
 */
.chipList.chipList.chipList > div {
  width: 100%;
}
